import React from 'react'
import { useNavigation } from 'hocs'
import { isLocalStorageAvailable } from 'utils/storage'
import SearchBar from 'uiComponents/search/searchBar'
import { t } from 'translations'
import './ordersSearchBar.scss'

export const getSearchByOptions = () => [
    { value: 'email', name: t('orders.orders.filters.searchBy.email') },
    { value: 'id', name: t('orders.orders.filters.searchBy.orderId') },
    { value: 'barcode', name: t('orders.orders.filters.searchBy.barcode') },
    { value: 'discount_code', name: t('orders.orders.filters.searchBy.discountCode') },
    { value: 'reference_id', name: t('orders.orders.filters.searchBy.reservationId') },
    { value: 'user_details', name: t('orders.orders.filters.searchBy.userDetails') },
    { value: 'comment', name: t('orders.orders.filters.searchBy.note') },
]

const OrdersSearchBar: React.FC = () => {
    const navigation = useNavigation()
    const query = navigation.query()

    const onSearchByChange = (searchBy: string) => {
        if (isLocalStorageAvailable()) {
            localStorage.setItem('orders_search_by', searchBy)
        }
    }

    const defaultSearchBy =
        query.searchBy || (isLocalStorageAvailable() ? localStorage.getItem('orders_search_by') : 'email') || 'email'

    return (
        <div className="orders-search-bar">
            <SearchBar
                key={query.search}
                searchByOptions={getSearchByOptions()}
                defaultSearchBy={defaultSearchBy}
                onSearchByChange={onSearchByChange}
                autoSearchByPatterns={[
                    [/@/, 'email'],
                    [/^\d{8,9}$/, 'id'],
                    [/^\d{14}$/, 'barcode'],
                    [/^\d{5}-\d{5}-\d{5}$/, 'reference_id'],
                ]}
            />
        </div>
    )
}

export default OrdersSearchBar
